import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';

export const freeChipsCampaignRoutes: Route[] = [
    {
        path: 'campaigns',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: 'free-chips',
                data: {
                    breadcrumbs: [{ label: 'campaigns.free-chips.breadcrumb' }],
                    actions: [
                        {
                            label: 'actions.new',
                            execute: (componentInstance) => {
                                componentInstance.openCreateDialog();
                            },
                        },
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/free-chips-campaign-list/free-chips-campaign-list.component'
                            ).then((c) => c.FreeChipsCampaignListComponent),
                    },
                ],
            },
        ],
    },
];
